// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__359tF","footer":"styles_footer__1kEOk"};